module.exports = __webpack_public_path__ + "img/LOADING.f8bdd982.gif";